var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {
        if ($('.block-recruitment-list').length > 0) {

            $('select').select2({
                minimumResultsForSearch: -1
            });

            // Filter

            function filter(){
                let category = $('.block-recruitment-list select[name="category"]').val();

                $('.block-recruitment-list__offer').each(function () {
                    let can = false;

                    let item_category = $(this).data('category');

                    if(item_category.search(category) != -1){
                        can = true;
                    }

                    if(can == true){
                        $(this).fadeIn(200);
                    }else{
                        $(this).fadeOut(200);
                    }
                })
            }

            $('.block-recruitment-list select[name="category"]').on('change', function () {
                filter();
            })

            // Sort

            function sort(){
                let method = $('.block-recruitment-list select[name="sort"]').val()

                if(method == 'latest'){
                    offers.sort(function(a, b) {
                        return a.date - b.date;
                    })
                }
                if(method == 'category'){
                    offers.sort((a, b) => {
                        let fa = a.category.toLowerCase(),
                            fb = b.category.toLowerCase();

                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    });
                }
                if(method == 'cities'){
                    offers.sort((a, b) => {
                        let fa = a.place.toLowerCase(),
                            fb = b.place.toLowerCase();

                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    });
                }
                if(method == 'alphabetically'){
                    offers.sort((a, b) => {
                        let fa = a.title.toLowerCase(),
                            fb = b.title.toLowerCase();

                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    });
                }

                for(var i in offers){
                    jQuery('.block-recruitment-list__offer[data-id="'+ offers[i]['id'] +'"]').css('order', i);
                }
            }

            let offers = []
            jQuery('.block-recruitment-list__offer').each(function () {
                offers.push({
                    id: jQuery(this).data('id'),
                    date: jQuery(this).data('date'),
                    title: jQuery(this).find('.title').text(),
                    category: jQuery(this).find('.category').text(),
                    place: jQuery(this).find('.place').data('raw'),
                });
            })

            $('.block-recruitment-list select[name="sort"]').on('change', function () {
                sort();
            })



        }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=recruitment-list', initializeBlock);
    }
});
